const GameAccessToolReducers = (state = false, action) => {
  switch (action.type) {
    case "openAccessTool":
      return (state = true);
    case "closeAccessTool":
      return (state = false);
    default:
      return state;
  }
};
export default GameAccessToolReducers;
